export default __webpack_public_path__ + "static/media/eggSconeClassDetail.c1fb00d3.jpg";